import { defineReactiveModel } from "vue-app-utils-web";
import { db, dbFns } from "@/db";
import { currentTime } from "@/utils/time";
import { useAppStore } from "@/store";
import getModel from "@/models/get-model";

const Model = {
  beforeCreate: function () {
    this.db = db;
    this.dbFns = dbFns;
    this.$store = useAppStore();
    this.currentTime = currentTime;
    this.getModel = getModel;
  }
};

export default defineReactiveModel(Model);
